<i18n lang='yml' src="../i18n/Dropzone.yml"></i18n>
<template>
  <div>
    <div ref="dropzone_box" class="dropzone">
      <div class="dz-message" data-dz-message>
          <span>{{ $t('upload_text') }}<br>{{ $t('accepted_types') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import Dropzone from 'dropzone';
  export default {
    props: ['accepted_types', 'max_files', 'param_name', 'url', 'edit', 'redirect_url', 'locale'],
    data() {
      return {
        contextType: null,
        contextId: null
      }
    },
    methods: {
      successRedirect: function(myDropzone, type, redirectUrl) {
        $('#modalAddResources').modal('hide');
        if(type === 'submit-close') {
          myDropzone.removeAllFiles();
        }
        else if(type === 'submit-view') {
          window.location.replace(Routes.content_path(myDropzone.component.contextType, myDropzone.component.contextId))
        }
        else {
          window.location.replace(redirectUrl)
        }
      },
      formatErrors: function(errors) {
        let list = `${this.$t('errors')}: <ul>`
        errors.forEach((error) => {
          list += `<li>${error}</li>`
        })
        list += "</ul>"
        return list
      }
    },
    mounted() {
      let documentObject = this
      this.$i18n.locale = this.locale;
      this.contextType = document.querySelector('#modalAddResources').dataset.contextType
      this.contextId = document.querySelector('#modalAddResources').dataset.contextId
      function uploadResources(event, type, myDropzone)
      {
        event.preventDefault();
        // Take all the queued dropzone files and send them in individual requests
        let files = myDropzone.getQueuedFiles();
        let list = files.length;
        let formData = (type == 'submit-asset') ? new FormData(document.forms.namedItem('upload-asset')) : new FormData(document.forms.namedItem('upload'));
        formData.append('context_type', myDropzone.component.contextType)
        formData.append('context_id', myDropzone.component.contextId)
        let request_type = (edit == 'true') ? 'PUT' : 'POST'
        // What we do on a failed upload
        let ajaxOnError = function(data, error) {
          if(type != 'submit-asset') {
            myDropzone.alertSuccess = $('#upload-success')
            myDropzone.alertError = $('#upload-error')
          }

          myDropzone.alertSuccess.addClass('d-none')
          myDropzone.alertError.removeClass('d-none')
        }
        // What we do on a successful upload
        let ajaxOnSuccess = function(data) {

          if(type != 'submit-asset') {
           myDropzone.alertSuccess = $('#upload-success')
           myDropzone.alertError = $('#upload-error')
            let modalHandle = window.PEERISTICS_RESOURCE_ADD_HANDLE;
            let raType = modalHandle.options.resource_attachable.type;
            let raId = modalHandle.options.resource_attachable.id;
            let lrId = data.id;
            modalHandle.dropzoneAttachResource(
                modalHandle,
                null,
                {
                    resource_attachable_id: raId,
                    resource_attachable_type: raType,
                    library_resource_id: lrId
                }
            );
          }
          list -= 1;
          if(list <= 0) {
            if(data.errors) {
              myDropzone.alertSuccess.addClass('d-none')
              myDropzone.alertError.removeClass('d-none')
              myDropzone.alertError.find('.message').html(myDropzone.component.formatErrors(data.errors))
            }
            else {
              myDropzone.alertError.addClass('d-none')
              myDropzone.alertSuccess.removeClass('d-none')
              setTimeout(function() {
                documentObject.successRedirect(myDropzone, type,  redirectUrl)
              }, 1000);
              return
            }
          }
        }
        let ajaxOptions = {
          type: request_type,
          url: url,
          dataType: 'json',
          data: formData,
          processData: false,
          contentType: false,
          success: ajaxOnSuccess,
          error: ajaxOnError
        }

        let has_files = false
        files.forEach(function(item, index){
          formData.append(paramName, files[index]);
          $.ajax(ajaxOptions)
          has_files = true
        });
        if(list == 0 && request_type == 'PUT' && !has_files) {
          $.ajax(ajaxOptions)
        }

      }
      Dropzone.autoDiscover = false;
      let types = this.accepted_types;
      let maxFiles = this.max_files;
      let url = this.url;
      let edit = this.edit
      let paramName = this.param_name;
      let upload = this.$refs.upload;
      let redirectUrl = this.redirect_url
      let _vm = this
      let dropzone = new Dropzone(this.$refs.dropzone_box, {
          url: url,
          redirectUrl: redirectUrl,
          paramName: paramName, // The name that will be used to transfer the file
          maxFilesize: 4000,
          acceptedFiles: types,
          autoProcessQueue: false,
          parallelUploads: 5,
          maxFiles: maxFiles,
          edit: edit,
          init: function() {  
              document.querySelector(".dz-hidden-input").setAttribute("aria-label", "Dropzone file upload")
              var myDropzone = this;
              myDropzone.component = _vm;
              myDropzone.alertError = $('#upload-asset-error')
              myDropzone.alertSuccess = $('#upload-asset-success')
              document.querySelector("button[type=submit-close-button]").addEventListener("click", function(e) {
                uploadResources(e,'submit-close', myDropzone);
              })
              document.querySelector("button[type=submit-view-button]").addEventListener("click", function(e) {
                uploadResources(e,'submit-view', myDropzone);
              })
              if(document.querySelector("#submit-asset") != null) {
                document.querySelector("#submit-asset").addEventListener("click", function(e) {
                  uploadResources(e,'submit-asset', myDropzone);
                })
              }
          }
      });
    } 
  }
</script>
